var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-confirmation',{attrs:{"title":"¡Muchas gracias por tu compra!","subtitle":"Nos comunicaremos contigo vía correo electrónico en máximo un día hábil."}})}
var staticRenderFns = []

export { render, staticRenderFns }